import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, ErrorHandler, inject, NgModule, provideAppInitializer} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

// Modules
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {ErrorInterceptor, JwtInterceptor} from '@core/interceptors';
import {SidenavComponent} from '@shared/components/sidenav';

// Components
import {AppComponent} from './app.component';
import {HomePageComponent} from './pages/home/home.component';

import {CookieService} from 'ngx-cookie-service';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import 'moment/locale/en-gb';
import {EnvironmentService} from '@services/environment/environment.service';
import * as Sentry from '@sentry/angular';
import {Router} from '@angular/router';
import {SsoComponent} from './pages/sso/sso.component';
import {AuthClientConfig, AuthModule} from '@auth0/auth0-angular';
import {OctDocumentService} from '@services/document/document.service';
import {configAuth0Initializer} from '@core/auth/auth.constants';
import {MenuComponent} from '@shared/components/menu';
import {NgxSonnerToaster} from 'ngx-sonner';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MenuComponent,
    AuthModule.forRoot(),
    SidenavComponent,
    HomePageComponent,
    SsoComponent,
    NgxSonnerToaster
  ],
  providers: [
    CookieService,
    provideAppInitializer(() => inject(EnvironmentService).init()),
    {provide: 'googleTagManagerId', useValue: 'G-KP90BTNPCN'},
    {
      provide: APP_INITIALIZER,
      useFactory: configAuth0Initializer,
      deps: [HttpBackend, AuthClientConfig, EnvironmentService, OctDocumentService],
      multi: true
    },
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}},
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
